import { SupplierForm } from "./SupplierForm";
import { useParams } from "react-router-dom";

export const CreateSupplierPage = () => {
    const { startingPageId } = useParams();

    return <SupplierForm startingPageId={startingPageId ?? "0"} />;
};
